module.exports = __webpack_public_path__ + "static/pic04-206535b5053f26ddca4e7739c590381e.jpg";